import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectAuthStatus } from 'reducers/auth';
import GoogleTranslateManager from 'components/languageDropdown/GoogleTranslateManager';

/**
 * Hook that ensures Google Translate works after authentication changes
 */
export const useGoogleTranslateOnAuth = () => {
    const authStatus = useSelector(selectAuthStatus);
    const previousAuthStatus = useRef(authStatus);
    const googleTranslate = GoogleTranslateManager.getInstance();
    
    useEffect(() => {
        // Check if user just logged in
        if (authStatus === 'signed_in' && previousAuthStatus.current !== 'signed_in') {
            
            // Mark that user just logged in
            sessionStorage.setItem('justLoggedIn', 'true');
            
            // Allow translations
            if ((window as any).googleTranslateCoordinator) {
                (window as any).googleTranslateCoordinator.allowTranslation();
            }
            
            // Get saved language preference
            const savedLanguage = localStorage.getItem('selectedLanguage');
            
            // Only initialize Google Translate if the language is not English
            if (savedLanguage && savedLanguage !== 'en') {
                // Initialize Google Translate after a delay to let the page settle
                setTimeout(() => {
                    
                    googleTranslate.initialize(savedLanguage).then((success) => {
                        if (success) {
                            googleTranslate.hideUIElements();
                            
                            // Give Google Translate time to fully initialize before applying language
                            setTimeout(() => {
                                googleTranslate.applyLanguage(savedLanguage);
                                
                                // Apply again after a delay to ensure it sticks
                                setTimeout(() => {
                                    const selectElement = document.querySelector('.goog-te-combo') as HTMLSelectElement;
                                    if (selectElement && selectElement.value !== savedLanguage) {
                                        googleTranslate.applyLanguage(savedLanguage);
                                    }
                                }, 2000);
                                
                                // Force refresh translation as final attempt
                                setTimeout(() => {
                                    if ((window as any).googleTranslateHelper) {
                                        (window as any).googleTranslateHelper.forceRefreshTranslation();
                                    }
                                }, 3000);
                            }, 500);
                        }
                    });
                }, 1500);
            }
            
            // Clear the login flag after 10 seconds
            setTimeout(() => {
                sessionStorage.removeItem('justLoggedIn');
            }, 10000);
        }
        
        // Update previous auth status
        previousAuthStatus.current = authStatus;
    }, [authStatus, googleTranslate]);
};